import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  creditGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  // Fields (add/edit credit form)
  addCreditFormRoot: {
    width: '100%',
  },
  dialogActionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(1),
  },
  userName: {
    marginLeft: theme.spacing(2),
  },
  closeButton: {
    padding: 0,
  },
}));
